import { createClient } from '@supabase/supabase-js'

// API config
// const isLocalhost =
//     window.location.hostname === "localhost" ||
//     window.location.hostname === "127.0.0.1";


export const SUPABASE_URL = "https://dcqpshqobeeupjoajzsi.supabase.co"

export const SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRjcXBzaHFvYmVldXBqb2FqenNpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MjQ2NzQ1NjMsImV4cCI6MjA0MDI1MDU2M30.z8nXjPD_vAs_jc_aYFVsmzpItJX7mSrEaCCFB36y7bQ"
// Create a single supabase client for interacting with your database
export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);

// Execute this function to create the profiles table in Supabase SQL editor
export const createProfilesTable = `
-- Create a table for public profiles
create table profiles (
  id uuid references auth.users on delete cascade not null primary key,
  display_name text,
  avatar_url text,
  bio text,
  website text,
  created_at timestamp with time zone default timezone('utc'::text, now()) not null,
  updated_at timestamp with time zone default timezone('utc'::text, now()) not null
);

-- Set up Row Level Security (RLS)
alter table profiles enable row level security;

-- Create policies
-- Allow users to view any profile
create policy "Profiles are viewable by everyone" on profiles
  for select using (true);

-- Allow authenticated users to update their own profile
create policy "Users can update their own profile" on profiles
  for update using (auth.uid() = id);

-- Allow authenticated users to insert their own profile
create policy "Users can insert their own profile" on profiles
  for insert with check (auth.uid() = id);

-- Create a function to handle new user signup
create or replace function public.handle_new_user()
returns trigger as $$
begin
  insert into public.profiles (id, display_name)
  values (new.id, new.email);
  return new;
end;
$$ language plpgsql security definer;

-- Create a trigger to call the function on new user signup
create trigger on_auth_user_created
  after insert on auth.users
  for each row execute procedure public.handle_new_user();
`;